var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6547_240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.896875 0 0 0.896875 0 2V8C0 9.10312 0.896875 10 2 10H3V11.5C3 11.6906 3.10625 11.8625 3.275 11.9469C3.44375 12.0312 3.64688 12.0125 3.8 11.9L6.33438 10H11C12.1031 10 13 9.10312 13 8V2C13 0.896875 12.1031 0 11 0H2ZM11 11H8V12C8 13.1031 8.89688 14 10 14H13.6656L16.2 15.9C16.35 16.0125 16.5531 16.0312 16.725 15.9469C16.8969 15.8625 17 15.6906 17 15.5V14H18C19.1031 14 20 13.1031 20 12V6C20 4.89687 19.1031 4 18 4H14V8C14 9.65625 12.6563 11 11 11Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6547_240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesSolid);
export default __webpack_public_path__ + "static/media/messages-solid.4774437d7621bf1d97b26cd144421d1b.svg";
export { ForwardRef as ReactComponent };